import _ from 'lodash';

export default function replaceById(data, items = [], options = {}) {
  const inject = _.concat([], data);
  const collection = _.clone(items);
  
  if (!inject.length) return collection;

  const idField = inject[0].uuid ? 'uuid' : 'id';

  _.forEach(inject, (item, n) => {
    const index = _.findIndex(collection, { [idField]: item[idField] });
    const replacement = options.skipMerge ? item : _.defaults({}, item, collection[index]);

    if (!options.skipInject && index === -1) {
      if (options.injectAt) return collection.splice(options.injectAt + n, 0, item);

      return collection.push(_.clone(item));
    }

    if (index !== -1) return collection.splice(index, 1, replacement);
  });

  return collection;
}



// WEBPACK FOOTER //
// ./app/utils/replace-by-id.js